import * as tslib_1 from "tslib";
import ComposeFromMenu from './ComposeFromMenu';
import ImportanceIcon from './ImportanceIcon';
import { observer } from 'mobx-react';
import { CommandButton, IconButton } from 'office-ui-fabric-react/lib/Button';
import { DraggableItemTypes } from 'owa-dnd/lib/utils/DraggableItemTypes';
import moveComposeToTab from 'owa-mail-compose-store/lib/actions/moveComposeToTab';
import showBccWell from 'owa-mail-compose-store/lib/actions/showBccWell';
import showCcWell from 'owa-mail-compose-store/lib/actions/showCcWell';
import switchToReadWriteRecipient from 'owa-mail-compose-store/lib/actions/switchToReadWriteRecipient';
import upConvert from 'owa-mail-compose-store/lib/actions/upConvert';
import updateLastFocusedControl from 'owa-mail-compose-store/lib/actions/updateLastFocusedControl';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import isReadingPaneCardUIEnabled from 'owa-mail-feature-flags/lib/isReadingPaneCardUIEnabled';
import CompactRecipientWell from 'owa-readonly-recipient-well/lib/components/CompactRecipientWell';
import ReadOnlyRecipientWell from 'owa-readonly-recipient-well/lib/components/ReadOnlyRecipientWell';
import mergeReadWriteRecipientWellIntoReadOnly from 'owa-readonly-recipient-well/lib/utils/mergeReadWriteRecipientWellIntoReadOnly';
import RecipientWellLabelWithContactPicker from 'owa-readwrite-recipient-well-fabric/lib/components/RecipientWellLabelWithContactPicker';
import convertPersonaToRecipientPersonaProps from 'owa-readwrite-recipient-well-fabric/lib/utils/convertPersonaToRecipientPersonaProps';
import ReadWriteRecipientWellWithFindControl from 'owa-readwrite-recipient-well/lib/components/ReadWriteRecipientWellWithFindControl';
import getRecipientString from 'owa-readwrite-recipient-well/lib/utils/getRecipientString';
import { RecipientType } from 'owa-recipient-common/lib/store/schema/RecipientType';
import strings from 'owa-strings/owa-mail-strings';
import isTabViewEnabled from 'owa-tab-store/lib/utils/isTabViewEnabled';
import * as React from 'react';
import { default as ReadWriteFabricRecipientWell, } from 'owa-readwrite-recipient-well-fabric/lib/components/ReadWriteFabricRecipientWell';
var styles = require('./ComposeTop.scss');
var classNames = require('classnames/bind').bind(styles);
var RecipientPanel = /** @class */ (function (_super) {
    tslib_1.__extends(RecipientPanel, _super);
    function RecipientPanel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Map for ComposeControl -> react component
        _this.controlMap = {};
        // Map for ComposeControl -> attached Html element
        _this.elementMap = {};
        _this.renderRWRecipientWellWithFindControl = function (recipientWell, recipientType, control) {
            var onInputFocus = function (evt) {
                updateLastFocusedControl(_this.props.composeViewState, control);
            };
            return (React.createElement(ReadWriteRecipientWellWithFindControl, { shouldBlockForcedFocus: recipientType == RecipientType.To, onInputFocus: onInputFocus, recipientWell: recipientWell, recipientType: recipientType, size: 1 /* Regular */, ref: function (ref) { return (_this.controlMap[control] = ref); } }));
        };
        _this.renderRWFabricRecipientWell = function (recipientWell, recipientType, control) {
            var onInputFocus = function (evt) {
                updateLastFocusedControl(_this.props.composeViewState, control);
            };
            return (React.createElement(ReadWriteFabricRecipientWell, { ref: function (ref) { return (_this.controlMap[control] = ref); }, onInputFocus: onInputFocus, draggableItemType: DraggableItemTypes.ReadWriteRecipient, dropViewState: recipientWell.dropViewState, extendedProps: {
                    recipientWell: recipientWell,
                    recipientType: recipientType,
                    onRenderWellLabel: _this.renderFabricWellLabel(control),
                } }));
        };
        _this.renderFabricWellLabel = function (control) { return function (props) {
            return (React.createElement(RecipientWellLabelWithContactPicker, tslib_1.__assign({}, props, { addRecipient: _this.addRecipientFromContactPicker(control) })));
        }; };
        _this.addRecipientFromContactPicker = function (control) { return function (recipientToAdd) {
            _this.controlMap[control].addItem(convertPersonaToRecipientPersonaProps([recipientToAdd]));
        }; };
        _this.renderRecipientWellLine = function (normalContent, flowContent) {
            return (React.createElement("div", { className: styles.recipientWellLine },
                normalContent,
                flowContent));
        };
        _this.renderMiniButtonPanel = function () {
            var _a = _this.props, showCompactRecipientWell = _a.showCompactRecipientWell, ccRecipientWell = _a.ccRecipientWell, bccRecipientWell = _a.bccRecipientWell, composeViewState = _a.composeViewState;
            var isInlineCompose = composeViewState.isInlineCompose, importance = composeViewState.importance;
            var showRecipientButton = !isInlineCompose || !showCompactRecipientWell;
            return (React.createElement("div", { className: styles.miniRecipientButtonContainer },
                isInlineCompose && React.createElement(ImportanceIcon, { importance: importance }),
                showRecipientButton &&
                    !ccRecipientWell && (React.createElement(CommandButton, { onClick: _this.onShowCc, className: styles.miniButton }, strings.ccLabel)),
                showRecipientButton &&
                    !bccRecipientWell && (React.createElement(CommandButton, { onClick: _this.onShowBcc, className: styles.miniButton }, strings.bccLabel)),
                isInlineCompose && (React.createElement(IconButton, { title: strings.upConvertTooltip, iconProps: { iconName: "FullScreen" /* FullScreen */ }, onClick: _this.onUpConvert, className: styles.miniButton }))));
        };
        _this.onUpConvert = function () {
            if (isTabViewEnabled()) {
                moveComposeToTab(_this.props.composeViewState, true /*isShown*/, true /*makeActive*/);
            }
            else {
                upConvert(_this.props.composeViewState);
            }
            _this.autoFocusControl = 3 /* RecipientWellCc */;
        };
        _this.onShowCc = function () {
            showCcWell(_this.props.composeViewState);
            _this.autoFocusControl = 3 /* RecipientWellCc */;
        };
        _this.onShowBcc = function () {
            showBccWell(_this.props.composeViewState);
            _this.autoFocusControl = 4 /* RecipientWellBcc */;
        };
        _this.onSwitchToReadWriteRecipient = function () {
            switchToReadWriteRecipient(_this.props.composeViewState);
            _this.autoFocusControl = 2 /* RecipientWellTo */;
        };
        _this.composeControlWillUpdate = function (composeControl) {
            _this.contentChangeSourceControl = composeControl;
            _this.originalHeight = _this.rootElement.clientHeight;
        };
        return _this;
    }
    RecipientPanel.prototype.render = function () {
        var _this = this;
        var _a = this.props, isFromShown = _a.isFromShown, showCompactRecipientWell = _a.showCompactRecipientWell, ccRecipientWell = _a.ccRecipientWell, bccRecipientWell = _a.bccRecipientWell, composeViewState = _a.composeViewState, senderPersona = _a.senderPersona;
        var isInlineCompose = composeViewState.isInlineCompose, fromViewState = composeViewState.fromViewState, toRecipientWell = composeViewState.toRecipientWell;
        var miniButtonPanel = this.renderMiniButtonPanel();
        if (isInlineCompose && showCompactRecipientWell) {
            var containerClassName = classNames(styles.recipientWellLine, styles.compact, isReadingPaneCardUIEnabled() && styles.cardUI);
            var compactRecipientWell = (React.createElement(CompactRecipientWell, { toRecipientWell: toRecipientWell, recipientType: RecipientType.To, ccRecipientWell: ccRecipientWell, onSwitchToReadWriteWell: this.onSwitchToReadWriteRecipient, className: styles.compactRecipientWell }));
            return (React.createElement("div", { className: containerClassName, ref: function (ref) { return (_this.rootElement = ref); } },
                senderPersona,
                compactRecipientWell,
                miniButtonPanel));
        }
        else {
            var fromField = isFromShown ? (React.createElement(ComposeFromMenu, { viewState: fromViewState, ref: function (ref) {
                    _this.controlMap[1 /* From */] = ref;
                    _this.elementMap[1 /* From */] = ref ? ref.getRootdiv() : null;
                } })) : null;
            var toRecipient = this.renderRecipientWell(toRecipientWell, RecipientType.To);
            var ccRecipient = ccRecipientWell && this.renderRecipientWell(ccRecipientWell, RecipientType.Cc);
            var bccRecipient = bccRecipientWell && this.renderRecipientWell(bccRecipientWell, RecipientType.Bcc);
            return (React.createElement("div", { ref: function (ref) { return (_this.rootElement = ref); } },
                fromField && this.renderRecipientWellLine(fromField, miniButtonPanel),
                this.renderRecipientWellLine(toRecipient, !fromField ? miniButtonPanel : null),
                ccRecipient && this.renderRecipientWellLine(ccRecipient),
                bccRecipient && this.renderRecipientWellLine(bccRecipient)));
        }
    };
    RecipientPanel.prototype.componentWillUpdate = function (nextProps) {
        if (this.props.isFromShown != nextProps.isFromShown) {
            this.composeControlWillUpdate(1 /* From */);
            return;
        }
        if (this.props.showCompactRecipientWell && !nextProps.showCompactRecipientWell) {
            this.composeControlWillUpdate(2 /* RecipientWellTo */);
            return;
        }
        if (!this.props.ccRecipientWell && nextProps.ccRecipientWell) {
            this.composeControlWillUpdate(3 /* RecipientWellCc */);
            return;
        }
        if (!this.props.bccRecipientWell && nextProps.bccRecipientWell) {
            this.composeControlWillUpdate(4 /* RecipientWellBcc */);
            return;
        }
    };
    RecipientPanel.prototype.componentDidUpdate = function () {
        // Check if there is content size change and notify parent on how much is changed
        if (this.contentChangeSourceControl) {
            var delta = this.rootElement.clientHeight - this.originalHeight;
            var sourceElement = this.elementMap[this.contentChangeSourceControl];
            this.props.onContentSizeChanged(delta, sourceElement);
            // Reset contentChangeSourceControl
            this.contentChangeSourceControl = null;
        }
        if (this.autoFocusControl) {
            switch (this.autoFocusControl) {
                case 2 /* RecipientWellTo */:
                case 3 /* RecipientWellCc */:
                case 4 /* RecipientWellBcc */:
                    var recipientWell = this.controlMap[this.autoFocusControl];
                    if (recipientWell) {
                        recipientWell.focus();
                    }
                    break;
            }
            // Reset it back
            this.autoFocusControl = null;
        }
    };
    RecipientPanel.prototype.focus = function () {
        // Focus can only happen when the recipient well is in read-write
        if (this.props.showCompactRecipientWell) {
            return;
        }
        // Focus goes to To recipient
        var toRecipientWell = this.controlMap[2 /* RecipientWellTo */];
        if (toRecipientWell) {
            toRecipientWell.focus();
        }
    };
    RecipientPanel.prototype.renderRecipientWell = function (recipientWell, recipientType) {
        var _this = this;
        var control;
        if (recipientType == RecipientType.To) {
            control = 2 /* RecipientWellTo */;
        }
        else if (recipientType == RecipientType.Cc) {
            control = 3 /* RecipientWellCc */;
        }
        else {
            control = 4 /* RecipientWellBcc */;
        }
        if (this.props.isReadOnly) {
            var recipients = [];
            mergeReadWriteRecipientWellIntoReadOnly(recipientWell, recipients);
            return (React.createElement("div", { className: styles.recipientWell, ref: function (ref) { return (_this.elementMap[control] = ref); } },
                React.createElement(ReadOnlyRecipientWell, { wellLabelText: getRecipientString(recipientType), recipients: recipients, className: styles.readOnlyRecipientWell, allowRenderEmptyWell: true })));
        }
        else {
            return (React.createElement("div", { className: styles.recipientWell, ref: function (ref) { return (_this.elementMap[control] = ref); } }, isMailFeatureEnabled('cmp-fabricRecipientWell')
                ? this.renderRWFabricRecipientWell(recipientWell, recipientType, control)
                : this.renderRWRecipientWellWithFindControl(recipientWell, recipientType, control)));
        }
    };
    RecipientPanel = tslib_1.__decorate([
        observer
    ], RecipientPanel);
    return RecipientPanel;
}(React.Component));
export default RecipientPanel;
//# sourceMappingURL=RecipientPanel.js.map